//#region Imports
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { isObjectEmpty } from 'clicklease-ui-elements';
import { AuthDataState, AuthErrorState, Credentials, UserData, UserInfoData } from './../../interfaces';
import { AuthDataFeatureName } from './auth-data.reducer';

const getIsLoaded = ({ isLoaded }: AuthDataState): boolean => isLoaded;

const getIsLoading = ({ isLoading }: AuthDataState): boolean => isLoading;

const getIsError = ({ error }: AuthDataState): boolean => isObjectEmpty(error);

const getIsCreatingUser = ({ isCreatingUser }: AuthDataState): boolean => isCreatingUser;

const getIsUserValid = ({ isUserValid }: AuthDataState): boolean | null => isUserValid;

const getIsOTPValid = ({ isOTPValid }: AuthDataState): boolean | null => isOTPValid;

const getIsOTPLoading = ({ isOTPLoading }: AuthDataState): boolean | null => isOTPLoading;

const getIsUpdatePasswordLoading = ({ isUpdatePasswordLoading }: AuthDataState): boolean => isUpdatePasswordLoading;

const getIsUpdatePasswordSuccess = ({ isUpdatePasswordSuccess }: AuthDataState): boolean => isUpdatePasswordSuccess;

const getIsUpdatePasswordError = ({ isUpdatePasswordError }: AuthDataState): boolean => isUpdatePasswordError;

const getAccessTokenSelector = ({ accessToken }: AuthDataState): string => accessToken;

const getDBO = ({ data }: AuthDataState): string => data.dbo;

const getDBOparsed = ({ data }: AuthDataState): Date => new Date(data.dbo);

const getError = ({ error }: AuthDataState): AuthErrorState => error;

const getLoginParams = ({ data }: AuthDataState): Credentials => ({
    username: data.phoneNumber,
    password: data.password,
});

const getUserSelected = ({ data }: AuthDataState): UserData => ({
    ssn: data.ssn,
    dbo: data.dbo,
    rosekey: data.rosekey
});

const getOTPData = ({ data }: AuthDataState) => ({
    otp: data.otp,
    phoneNumber: data.phoneNumber,
});

const getPhoneNumber = ({ data }: AuthDataState): string => data.phoneNumber;

const getLast4PhoneNumber = ({ data }: AuthDataState): string => {
    if (data.phoneNumber.length < 4) return data.phoneNumber;
    return data.phoneNumber.slice(-4);
};

const getRoseKey = ({ data }: AuthDataState): string => data.rosekey;

const getSSN = ({ data }: AuthDataState): string => data.ssn;

const getUserInfoData = ({ userInfoData }: AuthDataState): UserInfoData => userInfoData;

const getIsAdmin = ({ isAdmin }: AuthDataState): boolean => isAdmin;

export const AuthDataFeatureSelector =
    createFeatureSelector<AuthDataState>(AuthDataFeatureName);

export const isAuthErrorSelector = createSelector(
    AuthDataFeatureSelector,
    getIsError
);

export const isCreatingUserSelector = createSelector(
    AuthDataFeatureSelector,
    getIsCreatingUser
);

export const isAuthLoadedSelector = createSelector(
    AuthDataFeatureSelector,
    getIsLoaded
);

export const isAuthLoadingSelector = createSelector(
    AuthDataFeatureSelector,
    getIsLoading
);

export const isUserValidSelector = createSelector(
    AuthDataFeatureSelector,
    getIsUserValid
);

export const isOTPValidSelector = createSelector(
    AuthDataFeatureSelector,
    getIsOTPValid
);

export const isOTPLoadingSelector = createSelector(
    AuthDataFeatureSelector,
    getIsOTPLoading
);

export const isUpdatePasswordLoading = createSelector(
    AuthDataFeatureSelector,
    getIsUpdatePasswordLoading
);

export const isUpdatePasswordSuccess = createSelector(
    AuthDataFeatureSelector,
    getIsUpdatePasswordSuccess
);

export const isUpdatePasswordError = createSelector(
    AuthDataFeatureSelector,
    getIsUpdatePasswordError
);

export const getAccessToken = createSelector(
    AuthDataFeatureSelector,
    getAccessTokenSelector
);

export const loginParamsSelector = createSelector(
    AuthDataFeatureSelector,
    getLoginParams
);

export const getAuthErrorSelector = createSelector(
    AuthDataFeatureSelector,
    getError
);

export const getUserSelectedSelector = createSelector(
    AuthDataFeatureSelector,
    getUserSelected
);

export const getLast4PhoneNumberSelector = createSelector(
    AuthDataFeatureSelector,
    getLast4PhoneNumber
);

export const getOTPDataSelector = createSelector(
    AuthDataFeatureSelector,
    getOTPData
);

export const getPhoneNumberSelector = createSelector(
    AuthDataFeatureSelector,
    getPhoneNumber
);

export const getDBOSelector = createSelector(AuthDataFeatureSelector, getDBO);

export const getDBOparsedSelector = createSelector(
    AuthDataFeatureSelector,
    getDBOparsed
);

export const getRoseKeySelector = createSelector(
    AuthDataFeatureSelector,
    getRoseKey
);

export const getUserInfoDataSelector = createSelector(
    AuthDataFeatureSelector,
    getUserInfoData
);

export const getSSNSelector = createSelector(AuthDataFeatureSelector, getSSN);

export const getIsAdminSelector = createSelector(
    AuthDataFeatureSelector,
    getIsAdmin
);
